/**
 * Component Entry
 *
 */

import Textarea from './Textarea'
export default Textarea
export * from './Textarea'
